import { userAccount, userRegister } from './user-account';

export const frCA = { userAccount, userRegister };
